module.exports = __webpack_public_path__ + "static/media/phone-lg-full-en.7f56c968.png";